export const OUTAGES_ROUTE = '/outages';

export const OUTAGE_ROUTE = '/outages/:outageId';

export const OUTAGE_MILLWRIGHT_ROUTE =
  '/outages/:outageId/millwrights/:millwrightId';
